import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface ForecastingTabProps {
  propertyId: string;
}

const ForecastingTab: React.FC<ForecastingTabProps> = ({ propertyId }) => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Forecasting</CardTitle>
          <CardDescription>Forecasting tools and reports for this property.</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Forecasting features will be added here. Property ID: {propertyId}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ForecastingTab;
